export class AppMessage {

    static readonly ERROR_REQUEST_DEFAULT: string = 'Ocurrio un error en la petición';

    // LoginPage
    static readonly ERROR_LOGIN_WS: string = 'Ocurrio un error intentando el login';
    static readonly ERROR_LOGIN_EMAIL: string = 'Debe ingresar un correo valido';
    static readonly ERROR_LOGIN_PASSWORD: string = 'Debe ingresar un password valido';
    static readonly ERROR_LOGIN_INVALID: string = 'Usuario y/o contraseña incorrecta';
    static readonly ERROR_LOGIN_SOCIAL_INVALID: string = 'Token invalido';

    // Recuperar Contrasena
    static readonly ERROR_RECUPERAR_CONTRASENA: string = 'Error iniciando proceso de recuperar contraseña';
    static readonly SUCCESS_INTRUCCIONES_CORREO: string = 'Se ha enviado un mail a su correo con las instrucciones para recuperar su contraseña';

    // Registro Usuario
    static readonly ERROR_POST_REGISTRO_USUARIO_WS: string = 'Error registrando el usuario';

    // Cambiar Contrasena
    static readonly ERROR_CAMBIAR_CONTRASENA: string = 'Error cambiando su contraseña';

    // Cerrar Sesion
    static readonly CLOSE_SESION_POPUP_TITLE: string = 'Cerrar Sesión';
    static readonly CLOSE_SESION_POPUP_MSG: string = '¿Esta seguro que desea cerrar su sesión?';

    // SUCURSALES
    static readonly ERROR_GET_LISTA_SUCURSALES_WS: string = 'Error obteniendo listado de sucursales';

    // VIAJES
    static readonly ERROR_GET_LISTA_VIAJES_WS: string = 'Error obteniendo listado de viajes';
    static readonly ERROR_GET_DETALLE_VIAJE_WS: string = 'Error obteniendo detalle del viaje';
    static readonly ERROR_POST_FINALIZAR_VIAJE_WS: string = 'Error terminando viaje';

    // JORNADAS
    static readonly ERROR_GET_LISTA_JORNADAS_WS: string = 'Error obteniendo listado de jornadas';
    static readonly ERROR_GET_DETALLE_JORNADA_WS: string = 'Error obteniendo detalle de jornada';
    static readonly ERROR_PUT_INICIAR_JORNADA_WS: string = 'Error iniciando jornada';
    static readonly ERROR_PUT_CANCELAR_JORNADA_WS: string = 'Error cancelando jornada';
    static readonly ERROR_PUT_EDITAR_HORA_JORNADA_WS: string = 'Error editando hora de jornada';
    static readonly ERROR_PUT_CAMBIAR_SUCURSAL_JORNADA_WS: string = 'Error editando sucursal de jornada';

    // KPIS
    static readonly ERROR_GET_KPIS_JORNADAS_WS: string = 'Error obteniendo KPIS de jornadas';
    static readonly ERROR_GET_KPIS_CONDUCTORES_WS: string = 'Error obteniendo KPIS de conductores';

    // GESTION CONDUCTORES
    static readonly ERROR_GET_LISTA_CONDUCTORES_WS: string = 'Error obteniendo listado de conductores';
  static readonly ERROR_GET_DETALLE_CONDUCTOR_WS: string = 'Error obteniendo detalle de conductor';
    static readonly ERROR_PUT_CAMBIAR_ESTADO_CONDUCTORES_WS: string = 'Error cambiando estado';
    static readonly ERROR_PUT_FINALIZAR_JORNADA_CONDUCTORES_WS: string = 'Error finalizando jornada';
    static readonly ERROR_PUT_DESHACER_FINALIZAR_JORNADA_CONDUCTORES_WS: string = 'Error finalizando jornada';
    static readonly ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS: string = 'Error cambiando sucursal';

    // GESTION BUSES
    static readonly ERROR_GET_LISTA_MOVILES_WS: string = "Error obteniendo listado de moviles";
  static readonly ERROR_GET_DETALLE_MOVIL_WS: string = "Error obteniendo detalle del movil";
    static readonly ERROR_POST_EXTENDER_TIEMPO_MOVILES_WS: string = "Error obteniendo listado de moviles";
    static readonly ERROR_POST_CAMBIAR_ESTADO_MOVILES_WS: string = "Error obteniendo listado de moviles";

    // DESPACHADOR
    static readonly ERROR_GET_SERVICIOS_DESPACHADOR_WS: string = "Error obteniendo listado de servicios";
    static readonly ERROR_POST_CREAR_SERVICIO_DESPACHADOR_WS: string = "Error creando viaje comercial";
    static readonly ERROR_GET_PARADEROS_DESPACHADOR_WS: string = "Error obteniendo paraderos";
    static readonly ERROR_GET_TERMINALES_DESPACHADOR_WS: string = "Error obteniendo terminales";

  // KPIS
  static readonly ERROR_GET_PDF_WS: string = 'Error obteniendo PDF';
    static readonly ERROR_GET_PARADS_DESPACHADOR_WS: string = "Error obteiendo paradas"
    static readonly ERROR_PUT_EDITAR_HORA_INICIO_DESPACHADOR_WS: string = "Error actualizando hora"

    static readonly ERROR_PUT_ASIGNAR_MOVIL_DESPACHADOR_WS: string = "Error asignando movil"
    static readonly ERROR_PUT_ELIMINAR_MOVIL_DESPACHADOR_WS: string = "Error eliminando movil"

    static readonly ERROR_PUT_ASIGNAR_CONDUCTOR_DESPACHADOR_WS: string = "Error asignando conductor"
    static readonly ERROR_PUT_ELIMINAR_CONDUCTOR_DESPACHADOR_WS: string = "Error eliminando conductor"
}
